/**
 * Is a CSS colour light (true), dark (false) or unparseable (null)?
 * Accepts #rgb, #rrggbb, #rrggbbaa, rgb()/rgba(). Used where the widget's
 * `theme` flag cannot be trusted: it defaults to "dark" for every org that
 * never set one, including orgs whose custom colours are white.
 */
export function isLightColor(color?: string | null): boolean | null {
  if (!color) return null;
  const c = color.trim().toLowerCase();
  let r: number, g: number, b: number;
  const hex = c.match(/^#([0-9a-f]{3,8})$/);
  if (hex) {
    let h = hex[1];
    if (h.length === 3 || h.length === 4) h = h.split("").map((x) => x + x).join("");
    if (h.length !== 6 && h.length !== 8) return null;
    r = parseInt(h.slice(0, 2), 16);
    g = parseInt(h.slice(2, 4), 16);
    b = parseInt(h.slice(4, 6), 16);
  } else {
    const rgb = c.match(/^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/);
    if (!rgb) return null;
    r = +rgb[1];
    g = +rgb[2];
    b = +rgb[3];
  }
  // Perceived luminance (ITU-R BT.601), 0..255.
  return (0.299 * r + 0.587 * g + 0.114 * b) > 150;
}
